/*
 * @Date: 2019-08-26 18:42:46
 * @LastEditors: zwj
 * @LastEditTime: 2021-10-15 11:09:24
 */
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import BootstrapVue from 'bootstrap-vue'
import Notifications from 'vue-notification'
import Toasted from 'vue-toasted'
import globals from './globals'
import Popper from 'popper.js'
import 'element-ui/lib/theme-chalk/index.css'
import request from '@/utils/request'



import md5 from 'js-md5'
Vue.prototype.$md5 = md5
// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Notifications)
Vue.use(Toasted)

Vue.prototype.$http = request

// Global RTL flag
Vue.mixin({
  data: globals
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
